// Vue Routerインポート
import { createRouter, createWebHistory } from 'vue-router';
// 遷移するコンポーネントをインポート
import PageMain from './components/PageMain.vue'
import Login from './components/Login.vue'
import Password from './components/Password.vue'
import PasswordRegist from './components/PasswordRegist.vue'
// import KCard from './components/KCard.vue'
import KatudoTouroku1 from './components/KatudoTouroku1.vue'
import KatudoTouroku2 from './components/KatudoTouroku2.vue'
import KatudoTouroku3 from './components/KatudoTouroku3.vue'
import KatudoTouroku4 from './components/KatudoTouroku4.vue'
import KatudoTouroku5 from './components/KatudoTouroku5.vue'
import KatudoTouroku6 from './components/KatudoTouroku6.vue'
import KatudoMosikomi from './components/KatudoMosikomi.vue'
import KatudoMosikomiConfirm from './components/KatudoMosikomiConfirm.vue'
import KatudoMosikomiRegist from './components/KatudoMosikomiRegist.vue'
// import Home from './components/Home.vue'
import Mypage from './components/mypage.vue'
import MyMain from './components/MypageMain.vue'
import MyAnk from './components/MyAnketo.vue'
import MyID from './components/MyID.vue'
import MyKatudo from './components/MyKatudo.vue'
// import MyAnkCon from './components/MyAnketoConf.vue'

// ルーティング設定（URL→コンポーネントの紐付け）
const routes = [
    // {
    //     path: `/`,      //URLのパス
    //     name: `pageheader`,    //<router-link>で指定する名前
    //     component: PageHeader  //呼び出されるコンポーネント
    // },
    // {   //ホーム
    //     path: `/`,
    //     name: `Home`,
    //     component: Home
    // },
    {   //ログイン画面
        path: `/Login`,
        name: `Login`,
        component: Login,
		meta: { title: 'ログイン' }
    },
	{   //パスワード再発行画面
        path: `/Password`,
        name: `Password`,
        component: Password,
		meta: { title: 'パスワード再発行' }
    },
	{   //パスワード再発行完了画面
        path: `/PasswordRegist`,
        name: `PasswordRegist`,
        component: PasswordRegist,
		meta: { title: 'パスワード再発行（完了）' }
    },
	{
		path: '/katudo-touroku/first',
		name: 'KatudoTouroku1',
		component: KatudoTouroku1,
		meta: { title: '新規登録（はじめに）' }
	},
	{
		path: '/katudo-touroku/step1',
		name: 'KatudoTouroku2',
		component: KatudoTouroku2,
		meta: { title: '新規登録（基本情報）' }
	},
	{
		path: '/katudo-touroku/step2',
		name: 'KatudoTouroku3',
		component: KatudoTouroku3,
		meta: { title: '新規登録（連絡先）' }
	},
	{
		path: '/katudo-touroku/step3',
		name: 'KatudoTouroku4',
		component: KatudoTouroku4,
		meta: { title: '新規登録（その他）' }
	},
	// 確認画面
	{
		path: '/katudo-touroku/confirm',
		name: 'KatudoTouroku5',
		component: KatudoTouroku5,
		meta: { title: '新規登録（確認）' }
	},
	// 完了画面
	{
		path: '/katudo-touroku/registered',
		name: 'KatudoTouroku6',
		component: KatudoTouroku6,
		meta: { title: '新規登録完了' }
	},
	// 活動申込（ホーム）
    {
        path: `/`,      //URLのパス
        name: `pagemain`,    //<router-link>で指定する名前
        component: PageMain  //呼び出されるコンポーネント
    },
	{
		path: '/katudo-mousikomi',
		name: 'KatudoMosikomi',
		component: KatudoMosikomi,
		props: true,
		meta: { requiresAuth: true, title: '活動申込（申込理由/活動日程選択）' }
	},
	// 確認画面
	{
		path: '/katudo-mosikomi/confirm',
		name: 'KatudoMosikomiConfirm',
		component: KatudoMosikomiConfirm,
		meta: { requiresAuth: true, title: '活動申込（内容確認）' }
	},
	// 完了画面
	{
		path: '/katudo-mosikomi/registered',
		name: 'KatudoMosikomiRegist',
		component: KatudoMosikomiRegist,
		meta: { requiresAuth: true, title: '活動申込完了' }
	},
	// マイページ
	{
		path: '/mypage',
		name: 'Mypage',
		component: Mypage,
		meta: { requiresAuth: true, title: 'マイページ' },
		// vue-router内でのvue-routerの使用
		children: [{
			path: '/mypage',
			component: MyKatudo,
			props: true,
			// ↓必要か分からない...
			// meta: { requiresAuth: true }
		},{
			path:"questionnaire",
			component: MyAnk,
			name: MyAnk,
			meta: { title: 'アンケート' }
		},{
			path:"information",
			component: MyID,
			meta: { title: 'ID情報' }
		},{
			path:"news",
			component: MyMain,
			meta: { title: 'お知らせ' }
		},
		]
	},
];

//スクロール制御
const scrollBehavior = (to, from, savedPosition) => {
	if (savedPosition) {
		return savedPosition;
	} else {
		return { top: 0 }
	}
};

// Vue Routerインスタンスの生成と初期化
const router = createRouter({
    history: createWebHistory(), // スラッシュによる遷移
    routes, // ルーティング設定
	scrollBehavior, // スクロール制御
});

// リダイレクト設定（例：管理者）
router.beforeEach((to,from,next)=>{
	// const A = this.$router.path;
	if (to.matched.some(record => record.meta.requiresAuth) && !sessionStorage.getItem("LOGIN") ) {
		// confirmで確認
		if (window.confirm("このページはログインする必要があります。")){
			next({ path: '/login' ,query: {redirect: to.fullPath}});
		}
	} else{
		next();
	}
});

export default router;
